import {
  getPrice,
  getPassengers,
  getTotalPriceExamPCR,
  getDataLayer,
  getPlan
} from './checkoutData'
import { removeParameterFromUrl } from './url'

export function checkout ({ $sentry, $store: { state, getters } }) {
  try {
    const isPromo = state.quotation.promoCode.valid
    const selectedQuote = state.quotation.result[state.quotation.selectedQuote]
    const storageData = {
      alias: 'viagem',
      aliasEN: 'travel',
      api: {
        path: 'travels',
        version: 'v5'
      },
      cookieGA: state.travelSetup.params.cookieGA,
      countriesSelected: state.quotation.countriesSelected,
      default: {
        completePrice: getPrice(isPromo, selectedQuote)
      },
      ecommerceDataLayer: getDataLayer(state, selectedQuote, getters),
      lead: {
        uuid: state.travelSetup.lead.uuid
      },
      personalData: {
        cellphone: state.travelSetup.lead.leadPhone,
        email: state.travelSetup.lead.leadEmail,
        name: state.travelSetup.lead.leadName
      },
      plan: getPlan(state, selectedQuote, isPromo, getters),
      ...state.additional.pcr.active && {
        additional: {
          pcrExam: {
            persons: getPassengers(state.additional.pcr.listSelectedPassengers, state.additional.pcr.active),
            labelNameAdditional: 'Exame PCR (Covid 19)',
            labelTotalValue: getTotalPriceExamPCR(state.additional.pcr.currentValue.price, state.additional.pcr.listSelectedPassengers.length)
          }
        }
      },
      promo: {
        completePrice: (isPromo && selectedQuote.totalValue) || 0
      },
      redirect: '/seguro-viagem/#/obrigado',
      sessionName: 'ciclic:travel',
      ...(state.travelSetup.appSettings.campaign && { campaign: state.travelSetup.appSettings.partner.slug }),
      quotationUrl: removeParameterFromUrl(state.quotation.quotationUrl, 'promo_code'),
      promoCodeExpiration: state.quotation.promoCodeExpiration
    }
    sessionStorage.setItem('ciclic:product', JSON.stringify(storageData))
  } catch (error) {
    $sentry.logWithContext({
      ctx: {
        label: 'checkoutData',
        error
      },
      error
    })

    sessionStorage.setItem('ciclic:product', JSON.stringify({
      error: true
    }))
  }
}
